<template>
  <div>
    <transition name="show-hide">
      <div class="shooppingCart-container" ref="shooppingCartContainer" :class="isShow ? 'show-active' : 'hide-active'">
        <div class="shooppingCart-list" v-if="realShoppingCartList.total > 0">
          <div class="shooppingCart-list-head">
            <span>已选试题</span>
            <span>共 {{ realShoppingCartList.total }} 题</span>
            <a href="javascript:;" @click="deleteExercise(1)">清空试题</a>
          </div>
          <div class="shooppingCart-list-body shoppingCart-scrollbar">
            <div class="shooppingCart-list-card" v-for="item in realShoppingCartList.data" :key="item.id">
              <div class="shooppingCart-list-card-head">
                <p @click="toggleCartBody(item)">
                  <i :class="item.showFlag ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
                  <span>{{ item.type_name }}</span>
                  共 <em>{{ item.question.length }}</em> 题
                </p>
                <p><i class="el-icon-delete" @click.prevent.stop="deleteExercise(2, item)"></i></p>
              </div>
              <transition name="in-out">
                <div class="shooppingCart-list-card-body" v-show="item.showFlag">
                  <ul>
                    <li v-for="exercise in item.question" :key="exercise.id">
                      <p :title="exercise.title">{{ exercise.question_sort }}. <span v-html="exercise.title"></span></p>
                      <i class="el-icon-delete" @click="deleteExercise(3, exercise)"></i>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <!-- 试题篮空 -->
        <div class="shoppingCart-empty" v-else>
          <i class="iconfont icon-wushuju1"></i>
          <p>试题篮空空的，赶紧去挑选吧~</p>
        </div>
        <!-- 试题篮按钮 -->
        <div class="shooppingCart-btn" @click="toggleShoppingCart">
          <p>试题篮</p>
          <span>{{ realShoppingCartList.total }}</span>
        </div>
        <!-- 回到顶部按钮 -->
        <div class="shooppingCart-top-btn" v-show="scrollTop > 0" @click="toWindowTop">
          <i class="el-icon-caret-top"></i>
          <p>TOP</p>
        </div>
        <!-- 点击生成试卷 -->
        <div class="shooppingCart-generate-wrap">
          <div class="shooppingCart-generate-btn download" :class="realShoppingCartList.total == 0 ? 'emptyCart' : ''" @click="downloadQuestions">
            <p class="title">
              <i class="iconfont icon-plus-download"></i>
              试题下载
            </p>
            <p class="tips">将试题下载到word文档</p>
          </div>
          <div class="shooppingCart-generate-btn" :class="realShoppingCartList.total == 0 ? 'emptyCart' : ''" @click="generatePaper">
            <p class="title">
              <i class="iconfont icon-bianji"></i>
              试卷编辑
            </p>
            <p class="tips">生成并编辑试卷得分、排版等</p>
          </div>
        </div>
        <!-- 删除弹窗 -->
        <el-dialog :visible.sync="visible" :close-on-click-modal="false" :append-to-body="true" width="400px" :lock-scroll="true" center class="shopping-cart-dialog">
          <p><i class="iconfont icon-tixing2" style="font-size:40px;"></i></p>
          <p>{{ dialogTipMsg }}</p>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="comfirmSubmit">确 定</el-button>
            <el-button @click="visible = false">取 消</el-button>
          </span>
        </el-dialog>
        <!-- 下载试题弹窗 -->
        <el-dialog :visible.sync="downloadDialog" title="试卷下载" :close-on-click-modal="false" :append-to-body="true" width="600px" :lock-scroll="true" class="download-questions-dialog">
          <div class="row-item">
            <span class="label">纸张大小：</span>
            <el-radio-group class="paper-size-radio-group" v-model="paperSize">
              <div class="size-item" v-for="item in paperSizeData" :key="item.value">
                <img :src="item.img" />
                <el-radio :label="item.value">{{ item.label }}</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="row-item">
            <span class="label">试卷用途：</span>
            <el-radio-group class="paper-function-radio-group" v-model="paperFunction">
              <el-radio v-for="item in paperFunctionData" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </div>
          <div class="row-item">
            <span class="label">试卷内容：</span>
            <el-checkbox-group v-model="paperCon" class="paper-con-checkboxs">
              <el-checkbox v-for="item in paperConData" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </div>

          <div class="row-item">
            <span class="label">试卷价格：</span>
            <div class="right active-free" v-if="preDownloadInfo.is_promotion == 1">
              <div class="active-user-account">
                <span class="fre">免费</span>
                <span class="coins"
                  >账户剩余 <em> {{ preDownloadInfo.coin_balance }} </em> 学贝</span
                >
              </div>
              <div class="active-tips">{{ preDownloadInfo.promotion_desc }}</div>
            </div>
            <template v-else>
              <div class="right freeToDownload" v-if="preDownloadInfo.paid == 1">
                <div>
                  <span>本次下载 <em>免费</em> </span>
                  <span>（首次下载后15天内可免费重复下载）</span>
                </div>
                <div>
                  <span class="userAccount"
                    >账户剩余：<em> {{ preDownloadInfo.coin_balance }} </em> 学贝</span
                  >
                </div>
              </div>
              <template v-else>
                <div class="right yxtUser" v-if="preDownloadInfo.is_group == 1">
                  您当前为<span>云校通用户</span>，本次下载<em class="is-free"> 免费</em>
                </div>
                <div class="right vip-user" v-else-if="preDownloadInfo.is_paper_vip">
                  您当前为<span>组卷vip用户</span>，本次下载仅需<em class="need">  {{ preDownloadInfo.paper_vip_price }} </em>学贝，省<em class="save">
                    {{ preDownloadInfo.paper_vip_save_price }} </em
                  >学贝
                </div>
                <div class="right price" v-else>
                  <div class="coin">
                    <span class="file-price"
                      >本次下载需要 <em>{{ preDownloadInfo.price }}</em> 学贝</span
                    >，
                    <span class="user-account"
                      >账户剩余：<em>{{ preDownloadInfo.coin_balance }}</em> 学贝</span
                    >
                  </div>
                  <div class="vip-tip">
                    <p>
                      开通组卷VIP，300万试题解析任意看，还享<em>{{ preDownloadInfo.open_paper_vip_discount * 10 }}</em
                      >折组卷优惠，10大VIP特权<a :href="`${$data.$BASE_URL}vip`" target="_blank">立即开通</a>
                    </p>
                  </div>
                </div>
              </template>
            </template>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="createPaperOrder">下 载</el-button>
          </span>
        </el-dialog>
        <!-- 余额不足弹窗 -->
        <el-dialog :close-on-click-modal="true" :visible="balanceNotEnough" :append-to-body="true" @close="balanceNotEnough = false" width="500px" custom-class="dialog-commoon-style noCoin-download-dialog" v-if="balanceNotEnough">
          <template v-if="paperRechargeInfo">
            <ul class="recharge-tabs">
              <li v-for="item in rechargeTabs" :key="item.value" :class="rechargeTabActive == item.value ? 'active' : ''" @click="toggleRechargeTabs(item.value)">
                <span>{{item.name}}</span>
              </li>
            </ul>
            <div class="recharge-tab tab-1" v-show="rechargeTabActive == 1">
              <div class="coin-info">
                <span>下载需要：<em>{{ paperRechargeInfo.price }}</em> 学贝</span>
                <span>账户余额：{{ paperRechargeInfo.user_coin }} 学贝</span>
              </div>
              <ul class="wechat-wrap">
                <li v-for="(item, index) in qrCode" :key="index" :class="selectedIndex == index ? 'active' : ''" @click="showqrCode(item, index)">
                  <span class="xb-coins">{{item.display_amount}}学贝</span>
                  <span class="xb-money">{{item.total_fee}}元</span>
                  <span class="discount" v-if="item.promotion">{{item.promotion}}</span>
                  </li>
              </ul>
              <div class="qr-code-wrap">
                <qr-code :options="rechargeOptions" />
              </div>
              <p class="wechat-pay-tips">微信扫码支付 <span class="price">{{qrCode[selectedIndex].total_fee}}</span> 元 得 <span class="coins">{{qrCode[selectedIndex].coin_amount}}</span> 学贝</p>
              <div class="bottom-tips">学贝可用于下载教习网 <span class="total">400万</span> 精选资源，<span class="total">300万</span> 精选试题，在线组卷</div>
            </div>
            <div class="recharge-tab tab-2" v-show="rechargeTabActive == 2">
              <div class="top-tips">扫码支付{{paperRechargeInfo.order.total_fee}}元直接下载，充值下载可<span>省{{paperRechargeInfo.order.total_fee - paperRechargeInfo.recharge_price}}元</span>哦~</div>
              <div class="qr-code-wrap">
                <qr-code :options="payOptions" />
              </div>
              <p class="wechat-pay-tips">微信扫码支付<span class="price"> {{paperRechargeInfo.order.total_fee}} </span>元</p>
              <div class="bottom-tips">想免费下载此资料？<a class="link" :href="`${baseLink}user/home`" target="_blank">完善资料</a>，立得50学贝</div>
            </div>
            <vue-seamless :data="paperRechargeInfo.records" :class-option="classOption" class="recharge-slide">
                <ul>
                    <li v-for="(item,key) in paperRechargeInfo.records" :key="key">
                      {{item.name}}购买<span>{{item.coins}}学贝</span>
                    </li>
                </ul>
            </vue-seamless>
          </template>
        </el-dialog>
        <!-- 下载成功弹窗 -->
        <el-dialog :close-on-click-modal="false" title="下载成功" :visible="downSuccess" :append-to-body="true" @close="downSuccess = false" width="500px" custom-class="dialog-commoon-style down-success">
          <img src="../assets/images/download.png">
          <p class="success">下载成功</p>
          <p>按<span class="short-cut">{{shortCut}}</span>查看文件保存位置</p>
          <p class="down-again">若下载不成功，可<a :href="repeatDownPaperUrl" class="repeat-down">重新下载</a>，或查看<a href="https://www.51jiaoxi.com/articles_5/" target="_blank">资料下载帮助</a></p>
          <div class="share-btn hot-icon" @click="jumpToShare" v-if="isShare">共享组卷立返<span class="share-get-coins">{{shareCoins}}</span>学贝</div>
        </el-dialog>
      </div>
    </transition>
  </div>
</template>

<script>
var that, timer
import Cookies from 'js-cookie'
import { $BASE_URL } from '../utils/env'
import { mapGetters } from 'vuex'
import * as util from '../utils/util.js'
import qrCode from 'vue-qrcode-jc'
import axios from 'axios'
import { removePaperExercise } from '@/api/manual'
import { userInfor } from '@/api/header'
import { paperPreDownload, createPaperOrder, paperDownloadUrl, checkPaperOrder } from '@/api/paperEdit'
import vueSeamless from 'vue-seamless-scroll'
export default {
  name: 'shooppingCart',
  data() {
    return {
      isShow: false, // 显示隐藏试题篮
      visible: false, // 删除弹窗显示
      dialogTipMsg: '', // 传递给弹窗的文字信息
      scrollTop: 0, // 离顶部的距离
      realShoppingCartList: {
        // 试题篮数据
        total: 0,
        data: [],
      },
      $BASE_URL: $BASE_URL.replace('api', ''),
      deleteData: {}, // 删除试题参数
      downloadDialog: false, // 下载试题篮试题弹窗
      paperSize: '1',
      paperSizeData: [
        {
          label: 'A4',
          value: '1',
          img: require('../assets/images/paper1.png'),
        },
        {
          label: 'A3(双栏)',
          value: '2',
          img: require('../assets/images/paper2.png'),
        },
        {
          label: 'B5',
          value: '3',
          img: require('../assets/images/paper1.png'),
        },
        {
          label: 'B4(双栏)',
          value: '4',
          img: require('../assets/images/paper2.png'),
        },
      ],
      paperFunction: '1',
      paperFunctionData: [
        {
          label: '教师用卷 (每题后跟答案考点解析)',
          value: '1',
        },
        {
          label: '学生用卷 (答案考点解析集中在卷尾)',
          value: '2',
        },
      ],
      paperCon: ['1', '2', '3'],
      paperConData: [
        {
          label: '答案',
          value: '1',
        },
        {
          label: '考点',
          value: '2',
        },
        {
          label: '解析',
          value: '3',
        },
      ],
      preDownloadInfo: {},
      rechargeTabs: [
        {
           value: 1,
           name: '充值下载'
        },
        {
          value: 2,
          name: '扫码直接下载'
        }
      ],
      rechargeTabActive:1,
      paperRechargeInfo: {},
      balanceNotEnough: false, // 余额不足
      selectedIndex: 0, // 选中的二维码
      qrCode: [], // 充值规则
      qrcodeOptions: {
        width: 140, // canvas宽度
        height: 140, // canvas长度
        background: '#fff', // 固定字段 canvas背景色
        correctLevel: 2, // canvas容错等级   1 - 4
        foreground: '#000000', // canvas二维码填充色
        render: 'canvas', // canvas 渲染方法
        text: 'xxx', // canvas下方是否需要填写文本  ，  需要则直接输入文本  比如 "推广员 : AAA"
        codeUrl: '', // canvas 扫描的链接
        typeNumber: -1, // 固定字段
        imgSrc: require('../assets/images/wxPay.jpg'), // 是否需要在二维码中间存放图片， 需要则 直接输入图片链接
        imgWidth: 32, // canvas 中间图片渲染大小
        imgHeight: 32, // canvas 中间图片渲染大小
        textConfig: {
          // canvas下方文本字段配置
          textHeight: 0, // canvas下方文本字段占用高度
          fontSize: 36, // canvas 下方文本字段的大小
          color: '#fff', // canvas 下方文本字段的填充色
        },
      },
      rechargeOptions: {},
      payOptions: {},
      downSuccess: false,
      stage: '',
      subject: '',
      isShare: false,
      shareCoins: 0,
      shortCut: 'Ctrl + J',
      repeatDownPaperUrl:''
    }
  },
  components: {
    qrCode,
    vueSeamless
  },
  props: ['shoppingCartList'],
  computed: {
    ...mapGetters(['userInfo', 'baseLink']),
    classOption: function () {
      return {
        step: 0.8,
        limitMoveNum: 3,
        direction:2,
      }
    }
  },
  created() {
    that = this
    // 支付二维码配置
    that.rechargeOptions = JSON.parse(JSON.stringify(that.qrcodeOptions))
    that.payOptions = JSON.parse(JSON.stringify(that.qrcodeOptions))
  },
  mounted() {
    that.shortCut = util.findShortcutKey()
    window.addEventListener('scroll', that.scrollToTop) // 监听滚动事件
    document.getElementsByClassName('layout-container')[0].addEventListener('click', function(e) {
      // 点击其他区域关闭侧边栏
      let el = that.$refs.shooppingCartContainer
      if (el && !el.contains(e.target)) {
        that.isShow = false
      }
    })
  },
  watch: {
    shoppingCartList() {
      that.realShoppingCartList = that.shoppingCartList
      if (that.realShoppingCartList.paper_id) {
        // 返回paperId存到cookies
        Cookies.set('paperId', that.realShoppingCartList.paper_id, {
          expires: 7,
          path: '/',
          domain: that.$cookiesDomain,
        })
      }
      that.realShoppingCartList.data.forEach(item => {
        that.$set(item, 'showFlag', true)
      })
    },
    balanceNotEnough(val) {
      if (val) {
        timer = window.setInterval(() => {
          that.checkOrderStatus(that.paperRechargeInfo.order.order_no)
        }, 3000)
      } else {
        window.clearInterval(timer)
      }
    },
    downSuccess(val) {
      if(!val) {
        window.location.replace(`${that.baseLink}paper-${that.realShoppingCartList.paper_id}.html`)
      }
    }
  },
  methods: {
    /*------------------------------------- 功能交互 ------------------------------------------*/
    toggleShoppingCart() {
      // 判断是否存在用户信息，否则跳到登录；显示隐藏购物车
      if (that.userInfo) {
        that.isShow = !that.isShow
      } else {
        let url = encodeURIComponent(window.location.href)
        window.location.href = `${that.baseLink}login?redirect=${url}`
      }
    },
    scrollToTop() {
      // 监听滚动距离
      that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    },
    toWindowTop() {
      // 点击滚动回顶部
      util.scrollTop(0, 200)
    },
    toggleCartBody(item) {
      // 显示隐藏试题列表
      that.$set(item, 'showFlag', !item.showFlag)
    },
    deleteExercise(type, row) {
      // 删除试题
      let data = {
        type: type,
        paper_id: that.realShoppingCartList.paper_id,
      }
      if (type == 1) {
        // 清空全部
        that.dialogTipMsg = '确定要清空全部试题吗？'
      } else if (type == 2) {
        // 删除一类题
        if (row.type_name) {
          that.dialogTipMsg = `确定要删除【${row.type_name}】吗？`
        }
        data.type_id = row.id
      } else {
        // 删除一类题中的某道题
        that.dialogTipMsg = '确定要删除该试题吗？'
        data.question_id = row.question_id
      }
      that.deleteData = data
      that.visible = true
    },
    comfirmSubmit() {
      // 确定删除弹窗
      return new Promise((resolve, reject) => {
        removePaperExercise(that.deleteData)
          .then(res => {
            if (res.code === 200) {
              util.showTips('删除成功')
              that.$emit('refreshExercisesList', true)
              that.visible = false
            }
          })
          .catch(err => {
            util.locatioanToLogin(err)
          })
      })
    },
    generatePaper() {
      // 携参跳转到试卷编辑页面
      if (that.realShoppingCartList.total == 0) {
        return false
      }
      return new Promise((resolve, reject) => {
        userInfor()
          .then(res => {
            if (res.code == 200) {
              that.isShow = false
              const { href } = that.$router.resolve({
                name: 'paperEdit',
                query: {
                  paperId: that.realShoppingCartList.paper_id,
                },
              })
              window.open(href, '_self')
            }
          })
          .catch(err => {
            util.locatioanToLogin(err)
          })
      })
    },
    toggleRechargeTabs(val) {
      this.rechargeTabActive = val
    },
    // 下载试题篮试题
    downloadQuestions() {
      if (that.realShoppingCartList.total == 0) return false
      let data = {
        paper_id: that.realShoppingCartList.paper_id,
      }
      return new Promise((resolve, reject) => {
        paperPreDownload(data)
          .then(res => {
            if (res.code === 200) {
              that.preDownloadInfo = res.data
              that.isShow = false
              that.downloadDialog = true
            }
          })
          .catch(err => {
            util.locatioanToLogin(err)
          })
      })
    },
    // 创建订单
    createPaperOrder() {
      let data = {
        paper_id: that.realShoppingCartList.paper_id,
      }
      return new Promise((resolve, reject) => {
        createPaperOrder(data)
          .then(res => {
            if (res.code == 200) {
              that.downloadDialog = false
              if (res.data.paid == 1) {
                // 直接调获取下载地址的接口进行下载
                that.getDownloadUrl(res.data.order)
              } else {
                // 充值弹窗
                that.downloadDialog = false
                that.paperRechargeInfo = res.data
                let records = [];
                for(let key in that.paperRechargeInfo.records) {
                  let obj = {}
                  obj.name = key
                  obj.coins = that.paperRechargeInfo.records[key]
                  records.push(obj)
                }
                that.paperRechargeInfo.records = records
                that.qrCode = that.paperRechargeInfo.rechargeRules
                that.selectedIndex = 0
                that.rechargeOptions.codeUrl = that.paperRechargeInfo.rechargeRules[0].order.payments.wechat // 微信充值默认第一个
                that.payOptions.codeUrl = that.paperRechargeInfo.order.payments.wechat // 微信付款
                that.balanceNotEnough = true
                that.checkOrderStatus(that.paperRechargeInfo.order.order_no)
              }
            }
          })
          .catch(err => {
            util.locatioanToLogin(err)
          })
      })
    },
    // 根据订单号直接获取下载地址
    getDownloadUrl(order_no) {
      let data = {
        append: '1',
        order_no: order_no,
      }
      return new Promise((resolve, reject) => {
        paperDownloadUrl(data)
          .then(res => {
            if (res.code == 200 && res.data) {
              that.downloadDialog = false
              that.$myLoading.open()
              that.stage = res.stage_id
              that.subject = res.subject_id
              that.dowmloadPaper(`${res.data}&paper_id=${that.realShoppingCartList.paper_id}&paper_size=${that.paperSize}&type=${that.paperFunction}&question_structure=${that.paperCon.join(',')}`,res.shareable,(res.coin || 0))
            }
          })
          .catch(err => {
            that.$myLoading.hide()
            util.showTips('获取下载url失败')
          })
      })
    },
    // 金额不够，轮询订单
    checkOrderStatus(order_no) {
      let data = {
        order_no: order_no,
      }
      return new Promise((resolve, reject) => {
        checkPaperOrder(data).then(res => {
          if (res.code == 200) {
            that.balanceNotEnough = false
            that.getDownloadUrl(order_no)
            if (timer) {
              clearInterval(timer)
            }
          }
        })
      })
    },
    // 根据返回下载地址进行下载
    dowmloadPaper(url,share,coin) {
      let isSupportDownload = 'download' in document.createElement('a')
      if (isSupportDownload) {
        // 支持download属性
        axios
          .get(url, {
            withCredentials: true,
            responseType: 'arraybuffer',
          })
          .catch(err => {
            that.$myLoading.hide()
            util.showTips('网络繁忙，请稍后再试')
          })
          .then(res => {
            if (res && res.status == 200) {
              // type对应的格式
              const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
              const blobUrl = window.URL.createObjectURL(blob)
              const a = document.createElement('a')
              a.id = 'paper-download-dom'
              a.href = blobUrl
              // 截取文件名:文件名中有中文 则对文件名进行转码
              let str = decodeURIComponent(res.headers['content-disposition']),
                aPos = str.lastIndexOf("''"),
                bPos = str.lastIndexOf('.docx')
              let fileName = str.substring(aPos + 2, bPos)
              a.download = decodeURIComponent(fileName)
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(document.getElementById('paper-download-dom'))
              window.URL.revokeObjectURL(blobUrl)
              that.$myLoading.hide()
              that.repeatDownPaperUrl = url
              that.isShare = share
              that.shareCoins = coin
              that.downSuccess = true
            } else {
              that.$myLoading.hide()
            }
          })
      } else {
        window.open(url)
        that.$myLoading.hide()
        that.repeatDownPaperUrl = url
        that.isShare = share
        that.shareCoins = coin
        that.downSuccess = true
      }
    },
    jumpToShare() {
      const { href } = that.$router.resolve({
        name: 'share',
      })
      window.open(`${href}?stage_id=${that.stage}&subject_id=${that.subject}&paper_id=${that.realShoppingCartList.paper_id}`, '_blank')
      that.downSuccess = false
    },
    showqrCode(item, index) {
      // 切换充值面值
      that.selectedIndex = index
      that.rechargeOptions.codeUrl = that.paperRechargeInfo.rechargeRules[index].order.payments.wechat // 默认第一个
    },
  },
  destroyed() {
    // 离开页面移除滚动事件
    window.removeEventListener('scroll', that.scrollToTop)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.shooppingCart-container {
  position: fixed;
  top: 0;
  right: -370px;
  z-index: 999;
  zoom: 1;
  height: 100%;
  width: 370px;
  background: #f2f2f2;
  border-left: 2px solid #2b99ff;
  transition: all 0.28s ease-out;
  &.show-active {
    right: 0;
  }
  &.hide-active {
    right: -370px;
  }
  .shooppingCart-list {
    width: 100%;
    height: 100%;
    .shooppingCart-list-head {
      box-sizing: border-box;
      width: 100%;
      height: 40px;
      line-height: 20px;
      padding: 10px;
      overflow: hidden;
      & > span {
        float: left;
        font-size: 14px;
        color: #808080;
        &:nth-child(1) {
          font-size: 16px;
          margin-right: 10px;
          color: #333;
        }
      }
      & > a {
        float: right;
        font-size: 12px;
        color: #808080;
      }
      & > a:hover {
        color: #2b99ff;
      }
    }
    .shooppingCart-list-body {
      box-sizing: border-box;
      overflow-x: hidden;
      overflow-y: auto;
      width: 100%;
      height: calc(100% - 110px);
      &.shoppingCart-scrollbar::-webkit-scrollbar {
        width: 5px;
      }
      &.shoppingCart-scrollbar::-webkit-scrollbar-thumb {
        border-radius: 6px;
        background: #7b6f6f;
      }
      &.shoppingCart-scrollbar::-webkit-scrollbar-track {
        border-radius: 6px;
        background-color: transparent;
      }
      .shooppingCart-list-card {
        box-sizing: border-box;
        width: 100%;
        padding: 0 10px;
        background-color: #fff;
        margin-bottom: 10px;
        .shooppingCart-list-card-head {
          box-sizing: border-box;
          overflow: hidden;
          width: 100%;
          height: 40px;
          padding: 10px 0;
          color: #808080;
          border-bottom: 1px solid #f2f2f2;
          & > p:nth-child(1) {
            cursor: pointer;
            line-height: 20px;
            float: left;
            font-size: 14px;
            & > span {
              color: #333;
            }
            & > em {
              color: #2b99ff;
            }
          }
          & > p:nth-child(2) {
            line-height: 20px;
            float: right;
            font-size: 14px;
            cursor: pointer;
            &:hover > i {
              color: #e6321a;
            }
          }
        }
        .shooppingCart-list-card-body {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          padding: 10px 0;
          overflow: hidden;
          & > ul {
            width: 100%;
            height: 100%;
            overflow: hidden;
            & > li {
              width: 100%;
              height: 100%;
              overflow: hidden;
              padding: 5px 3px;
              box-sizing: border-box;
              font-size: 12px;
              color: #4d4d4d;
              cursor: default;
              &:hover {
                background-color: #f5f7fa;
              }
              &:hover > i {
                display: inline-block;
                padding-top: 3px;
              }
              & > p {
                float: left;
                width: 88%;
                line-height: 18px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              & > i {
                display: none;
                float: right;
                font-size: 14px;
                cursor: pointer;
                &:hover {
                  color: #e6321a;
                }
              }
            }
          }
        }
      }
    }
  }
  .shoppingCart-empty {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 200px 0;
    color: #ccc;
    & > i {
      font-size: 50px;
    }
    & > p {
      line-height: 30px;
      font-size: 14px;
    }
  }
  .shooppingCart-btn {
    position: absolute;
    left: -34px;
    top: 50%;
    box-sizing: border-box;
    margin-top: -16px;
    width: 32px;
    height: 120px;
    background: #2b99ff;
    border-radius: 2px 0px 0px 2px;
    padding: 15px 5px;
    text-align: center;
    cursor: pointer;
    & > i {
      font-size: 16px;
      color: #fff;
    }
    & > p {
      margin: 5px 0;
      line-height: 18px;
      font-size: 14px;
      color: #fff;
    }
    & > span {
      display: inline-block;
      width: 22px;
      height: 22px;
      line-height: 22px;
      border-radius: 50%;
      background-color: #e6321a;
      font-size: 12px;
      color: #fff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .shooppingCart-generate-wrap {
    position: absolute;
    left: 0;
    bottom: 0;
    overflow: hidden;
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 5px 0 0 rgba(0, 0, 0, 0.12), 0 0 5px 0 rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > .shooppingCart-generate-btn {
      width: 170px;
      height: 52px;
      background: #2b99ff;
      border-radius: 2px;
      &.download {
        background-color: #f60;
      }
      cursor: pointer;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      .title {
        width: 100%;
        font-size: 14px;
        color: #fff;
        line-height: 20px;
      }
      .tips {
        width: 100%;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.75);
        line-height: 16px;
      }
      &.emptyCart {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
  .shooppingCart-top-btn {
    position: absolute;
    left: -34px;
    top: 85%;
    box-sizing: border-box;
    cursor: pointer;
    background-color: #2b99ff;
    color: #fff;
    width: 32px;
    height: 32px;
    text-align: center;
    font-size: 12px;
    border-radius: 2px 0px 0px 2px;
    padding: 2px 0;
  }
  .in-out-enter-active,
  .in-out-leave-active {
    height: auto;
  }
  .in-out-enter,
  .in-out-leave-active {
    height: 0;
  }
}
.shopping-cart-dialog {
  .el-dialog__header {
    padding: 0;
  }
  p:nth-child(1) {
    color: #f60;
    font-size: 40px;
    text-align: center;
  }
  p:nth-child(2) {
    font-size: 16px;
    color: #333;
    text-align: center;
    margin-top: 12px;
  }
}
.download-questions-dialog {
  .el-dialog__header {
    padding: 13px 15px;
    border-bottom: 1px solid #ddd;
    .el-dialog__title {
      font-size: 16px;
      color: #333;
    }
    .el-dialog__headerbtn {
      right: 15px;
      top: 12px;
      font-size: 20px;
    }
  }
  .el-dialog__body {
    padding: 30px;
    width: 100%;
    box-sizing: border-box;
    .row-item {
      width: 100%;
      color: #333;
      overflow: hidden;
      & + .row-item {
        margin-top: 25px;
      }
      .label {
        float: left;
        color: #666;
        line-height: 16px;
      }
      .right {
        width: 100%;
        padding-left: 80px;
        &.active-free {
          .active-user-account {
            line-height: 14px;
            font-size: 14px;
            margin-bottom: 10px;
            .fre {
              display: inline-block;
              color: #3aa60d;
              padding-right: 15px;
              border-right: 1px solid #999;
            }
            .coins {
              padding-left: 15px;
              color: #999;
            }
          }
          .active-tips {
            color: #f60;
          }
        }
        &.price {
          .coin {
            margin-bottom: 10px;
            span {
              color: #999;
              em {
                color: red;
              }
            }
          }
          .vip-tip {
            background-color: #fef6e9;
            width: 540px;
            display: flex;
            margin-left: -88px;
            padding: 7px 5px;
            p {
              color: #ff6600;
              margin-left: 10px;
              margin-bottom: 0;
            }
            a {
              width: 54px;
              height: 20px;
              padding: 4px 8px;
              background: #2b99ff;
              border-radius: 2px;
              color: #fff;
              font-size: 12px;
              text-align: center;
              line-height: 20px;
              margin-left: 10px;
            }
          }
        }
        &.freeToDownload {
          div {
            margin-bottom: 10px;
            span {
              color: #999;
              em {
                color: red;
              }
            }
          }
        }
        &.yxtUser {
          margin-bottom: 10px;
          color: #999;
          line-height: 18px;
          span {
            color: #ff6600;
          }
          em {
            color: #3aa60d;
          }
        }
        &.vip-user {
          color: #333;
          font-size: 14px;
          line-height: 18px;
          span {
            color: #ff6600;
          }
          em {
            color: #ff0000;
          }
        }
      }
    }
  }
  .el-dialog__footer {
    text-align: center;
    padding: 20px 20px 30px;
    .el-button {
      width: 145px;
      height: 40px;
      line-height: 40px;
      padding: 0;
      font-size: 14px;
    }
  }
}
.noCoin-download-dialog {
  .el-dialog__header {
    padding: 0;
    border: none;
    .el-dialog__headerbtn {
      font-size: 15px;
      top: 8px;
      right: 10px;
    }
  }
  .el-dialog__body {
    padding: 0 !important;
    overflow: initial;
    .recharge-tabs {
      overflow: hidden;
      border-bottom: 1px solid #eee;
      padding: 0 35px !important;
      li {
        float: left;
        width: 50%;
        line-height: 50px;
        text-align: center;
        &:first-child {
          position: relative;
          &:after {
            content: '|';
            position: absolute;
            color: #ddd;
            right: -2px;
            font-size: 20px;
          }
        }
        &.active {
          color: #2b99ff;
          span {
            border-bottom-color: #2b99ff;
          }
        }
        span {
          display: inline-block;
          height: 100%;
          border-bottom: 2px solid transparent;
          cursor: pointer;
          font-size: 16px;
        }
      }
    }
    .recharge-tab {
      padding: 0 35px !important;
      .coin-info {
        margin: 15px 0 20px 0;
        span {
          color: #000;
          &:first-child {
            margin-right: 10px;
          }
          &:nth-child(2) {
            color: grey;
          }
          em {
            color: red;
          }
        }
      }
      .wechat-wrap {
        text-align: center;
        li {
          box-sizing: border-box;
          display: inline-block;
          width: 130px;
          height: 54px;
          border-radius: 2px;
          border: 1px solid #eee;
          cursor: pointer;
          position: relative;
          padding: 7px 0 5px;
          margin-left: 16px;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            border: 1px solid #2b99ff;
            background: #e0f3fc;
          }
          span {
            display: block;
            text-align: center;
            &.xb-coins {
              line-height: 21px;
              font-weight: 600;
              font-size: 16px;
              color: #000;
            }
            &.xb-money {
              font-size: 12px;
              color: #666;
              margin-top: 3px;
            }
            &.discount {
              position: absolute;
              padding: 0 4px;
              text-align: center;
              background: #f60;
              border-radius: 0 6px;
              font-size: 12px;
              color: #fff;
              line-height: 18px;
              right: -1px;
              top: 0;
              margin-top: -9px;
            }
          }
        }
      }
      .qr-code-wrap {
        margin-top: 20px;
        text-align: center;
        & > div {
          display: inline-block;
          border: 1px solid #f2f2f2;
          padding: 10px;
        }
      }
      .wechat-pay-tips {
        margin: 10px 0 15px 0;
        text-align: center;
        span {
          color: red;
        }
        .price {
          font-size: 16px;
          font-weight: 600;
        }
      }
      .bottom-tips {
        padding: 12px 0;
        text-align: center;
        border-top: 1px solid #eee;
        .total {
          color: #f60;
        }
        .link {
          color: #2b99ff;
        }
      }
      .top-tips {
        text-align: center;
        margin: 30px 0 15px 0;
        color: #333;
        span {
          color: red;
        }
      }
      &.tab-2 {
        .wechat-pay-tips {
          margin-bottom: 50px;
        }
      }
    }
    .recharge-slide {
        width: 480px;
        height: 36px;
        background-color: #f2f2f2;
        padding: 0 10px;
        overflow: hidden;
        & > div {
          width: 7000px !important;
          ul{
              height: 36px;
              line-height: 38px;
              overflow: hidden;
              li {
                  margin-right:20px;
                  float:left;
                  text-align:left;
                  &:first-child{
                      margin-left: 0;
                  }
                  span {
                      color: #2b99ff;
                  }
              }
          }
        }
    }
  }
}
.down-success {
    .el-dialog__body {
      margin-bottom: 0;
      padding-top: 40px !important;
      text-align: center;
      p {
        margin-top: 10px;
        .short-cut {
            font-size: 18px;
            color:red;
            padding: 0 5px;
        }
        &.success {
            font-size: 18px;
        }
        &.down-again {
            color: #666;
            font-size: 12px;
            a {
                color: #2b99ff;
                text-decoration: underline;
            }
        }
    }
    .share-btn {
        display: inline-block;
        vertical-align: middle;
        border-radius: 2px;
        padding: 0 10px;
        height: 36px;
        margin-top: 40px;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
        background-color: #2b99ff;
        color: #fff;
        &:hover {
          background-color: #067ff3;
        }
        &.hot-icon {
          position: relative;
          &:before {
              content: "Hot";
              position: absolute;
              top: -8px;
              right: -16px;
              padding: 0 4px;
              background-color: #f60;
              color: #fff;
              font-size: 12px;
              line-height: 16px;
              text-align: center;
              border-radius: 2px;
          }
        }
      }
    }
}
</style>
